import { z } from "zod";

export const FormSchema = z.object({
  ncm: z.string().min(2, "O NCM deve ter pelo menos 2 caracteres."),
  state: z.string().min(1, "Selecione uma UF válida."),
  is_active: z.boolean(),
  iva: z.string().min(1, "IVA é obrigatório."),
  internal_tax_rate: z
    .string()
    .min(1, "Taxa de imposto interno é obrigatória."),
  interstate_tax: z.string().min(1, "Taxa interestadual é obrigatória."),
});
